<template>
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50056 8.16406L6.98865 8.7335L6.50056 9.15187L6.01246 8.7335L6.50056 8.16406ZM5.75056 1.00098C5.75056 0.586763 6.08634 0.250976 6.50056 0.250976C6.91477 0.250976 7.25056 0.586763 7.25056 1.00098L5.75056 1.00098ZM11.7029 4.69269L6.98865 8.7335L6.01246 7.59462L10.7268 3.5538L11.7029 4.69269ZM6.01246 8.7335L1.29818 4.69269L2.27437 3.5538L6.98865 7.59462L6.01246 8.7335ZM5.75056 8.16406L5.75056 1.00098L7.25056 1.00098L7.25056 8.16406L5.75056 8.16406Z"
      fill="url(#paint0_linear_3490_10315)"
    />
    <path
      d="M12 11.1016H1"
      stroke="url(#paint1_linear_3490_10315)"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3490_10315"
        x1="11.2148"
        y1="4.58252"
        x2="1.78627"
        y2="4.58252"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3490_10315"
        x1="12"
        y1="11.6016"
        x2="1"
        y2="11.6016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
